import { LinkBreak, WarningCircle } from "@phosphor-icons/react";

import AccountsTag, {
  type AccountsTagVariantType,
} from "common/components/ui/AccountsTag";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaceAccounts from "common/datahooks/useWorkspaceAccounts";

import { stripTextHighlight } from "../../utils";
import HighlightedText from "../HighlightedText";

import type { JSX, ReactNode } from "react";

interface ConversationOwnerTagProps {
  accountId: string;
  fullNameHighlight: string;
}

export default function ConversationOwnerTag({
  accountId,
  fullNameHighlight,
}: ConversationOwnerTagProps) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { workspaceAccounts, isLoadingWorkspaceAccounts } =
    useWorkspaceAccounts(workspaceId);

  let rightComponent: JSX.Element;
  let textContent: ReactNode;
  let tooltipContent: string;
  //this className changes based on the state
  let variant: AccountsTagVariantType = "purple";

  const account = workspaceAccounts?.find(({ id }) => id === accountId);

  if (account) {
    if (account.state === "LoggedOut") {
      variant = "disabled";
      rightComponent = <LinkBreak />;
      tooltipContent = "Disconnected";
    } else if (!account.license && account.type !== "rental") {
      variant = "disabled";
      rightComponent = <WarningCircle weight="fill" />;
      tooltipContent = "No seat";
    }
    const { full_name } = account;
    textContent =
      fullNameHighlight &&
      stripTextHighlight(fullNameHighlight) === full_name ? (
        <HighlightedText>{fullNameHighlight}</HighlightedText>
      ) : (
        full_name
      );
  }

  return (
    <AccountsTag
      accounts={account ? [account] : []}
      isLoading={isLoadingWorkspaceAccounts}
      tooltipContent={tooltipContent}
      rightComponent={rightComponent}
      variant={variant}
      size="sm"
    >
      {textContent}
    </AccountsTag>
  );
}
